import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Redirect } from "react-router-dom";

import * as AppUrls from "../../../constants/AppUrls";

import NavbarOnboarding from "../NavbarOnboarding/NavbarOnboarding";

import { PersonFill, Person, People, PeopleFill } from "react-bootstrap-icons";
import { signal } from "@preact/signals-react";

// import personalImg from '../../../assets/images/Sharjah/person.png';
// import corporateImg from '../../../assets/images/Sharjah/cor.png';

import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import i18next from "i18next";
 import KYCimg from "../../../assets/images/Sharjah/KYC.png";
// import KYCimg from "../../../assets/images/ADCB/Onboarding/KYC.png";
import Personalimg from "../../../assets/images/Sharjah/Onboarding/Personal.png";
import CorporateImg from "../../../assets/images/Sharjah/Onboarding/Corporate.png";
import MinorImg from "../../../assets/images/Sharjah/Onboarding/Minor.png";

export const groupIdSignal = signal(null);

function OnboardingHome() {
  const { t } = useTranslation();

  const [redirect, setRedirect] = useState(null);
  const handleBack = (e) => {
    e.preventDefault();
    setRedirect(AppUrls.onboarding);
  };

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <>
      <NavbarOnboarding />

      <div className="login-main-container">
        <div className="KYCDivImg">
          <h2 className="OpenYourAccountwithUs">{t("OpenYourAccountwithUs")}</h2>
          <img className="KYCImg" src={KYCimg} alt="KYC" />
        </div>
        <div className="login-container">
          <div className="login-form">
            <h2 style={{ marginBottom: "2rem", fontWeight: "600" }}>{t("SelectAccountType")}</h2>
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", width: "90%" , margin: "0  auto" }}>
              {/* <div className='OnboardingHomeDiv' onClick={(e) => { setRedirect(AppUrls.onboardingPersonal) }}> */}
              <div
                className="OnboardingHomeDiv"
                onClick={(e) => {
                  groupIdSignal.value = "Personal";
                  setRedirect(AppUrls.onboardingLogin);
                }}>
                {/* <PersonFill size={100} color="#0b1d81" /> */}         
                <img className="PersonIcon" src={Personalimg} alt="Person Icon" width={35} height={40} />
                <button className="OnboardingHomeBtn">{t("personal")}</button>
              </div>
              <div
                className="OnboardingHomeDiv"
                onClick={(e) => {
                  groupIdSignal.value = "Minor";
                  setRedirect(AppUrls.onboardingLogin);
                }}>
                {/* <PersonFill size={100} color="#0b1d81" /> */}
                <img className="MinorIcon" src={MinorImg} alt="Minor Icon" width={30} height={50} />
                <button className="OnboardingHomeBtn">{t("Minor")}</button>
              </div>
              {/* <div className='OnboardingHomeDiv' onClick={(e) => { setRedirect(AppUrls.onboardingCorporate) }} > */}
              <div
                className="OnboardingHomeDiv"
                onClick={(e) => {
                  groupIdSignal.value = "Corporate";
                  setRedirect(AppUrls.onboardingLogin);
                }}>
                {/* <PeopleFill size={100} color="#0b1d81" /> */}
                <img className="CorporateImg" src={CorporateImg} alt="CorporateImg" width={40} height={40} />
                <button className="OnboardingHomeBtn">{t("corporate")}</button>
              </div>
            </div>
            <div>
              {/* <button
                                className={"link"}
                                style={{
                                    width: "100%",
                                    textDecoration: 'underline',
                                    marginTop: "1rem",
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                    backgroundColor: "transparent",
                                    border: "none",
                                    cursor: "pointer",

                                }}
                                onClick={handleBack}
                            >
                                {t("cancelForgotPassword")}
                            </button> */}
              {/* <button className="backBtn" onClick={handleBack}>
                {t("back")}
              </button> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OnboardingHome;
